var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3168_37809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.90501C16.4667 3.90501 20.0952 7.53358 20.0952 12.0002C20.0952 16.4669 16.4667 20.0955 12 20.0955C7.53333 20.0955 3.90476 16.4669 3.90476 12.0002C3.90476 7.53358 7.53333 3.90501 12 3.90501ZM12 2.00024C6.47619 2.00024 2 6.47643 2 12.0002C2 17.5241 6.47619 22.0002 12 22.0002C17.5238 22.0002 22 17.5241 22 12.0002C22 6.47643 17.5238 2.00024 12 2.00024Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3905 7.71454H15.0476C14.9238 7.71454 14.8 7.76216 14.7143 7.8574L11.9143 10.6574L9.11429 7.8574C9.02858 7.77168 8.90477 7.71454 8.78096 7.71454H7.4381C7.00953 7.71454 6.80001 8.22882 7.10477 8.52406L10.581 12.0003L7.10477 15.4764C6.80953 15.7717 7.01905 16.286 7.4381 16.286H8.78096C8.90477 16.286 9.02858 16.2383 9.11429 16.1431L11.9143 13.3431L14.7143 16.1431C14.8 16.2288 14.9238 16.286 15.0476 16.286H16.3905C16.8191 16.286 17.0286 15.7717 16.7238 15.4764L13.2476 12.0003L16.7238 8.52406C17.0191 8.22882 16.8095 7.71454 16.3905 7.71454Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3168_37809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2.00024)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/CloseCircle.b7ed7be3f3bbb08618394e8813d83426.svg";
export { ForwardRef as ReactComponent };